<template>
    <div class="app-inner">
         <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="$router.push('/recruit')" style="margin-left:0">
                返回
            </div>
            </div>
              <div class="businessList-container">
        <div class="businessList-container-table">
                        <el-table
            :data="itemList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="id"
            label="简历ID"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="name"
            label="文件名称"
           align="center"
           width="400"
            >
            </el-table-column>
            <el-table-column
            prop="deliveryTime"
            label="投递时间"
           align="center"
            >
            </el-table-column>
              <el-table-column
            prop="followNum"
            label="跟进次数"
           align="center"
            >
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            >
              <template slot-scope="scope">
                <div >
                    <el-button type="text" size="small" @click.stop="openWater(scope.row)" style="color:red">查看跟进</el-button>
                <el-button type="text" size="small" style="color:red">
                     <a :href="scope.row.filePath" style="color:red" v-if="$util.getResourceType(scope.row.filePath) == 'unknown'">下载简历</a>
                     <span v-if="$util.getResourceType(scope.row.filePath) == 'img'" style="color:red"
                     @click="$util.downloadIamge(scope.row.filePath,'个人简历')"
                     >下载简历</span>
                      <span v-if="$util.getResourceType(scope.row.filePath) == 'pdf'" style="color:red"
                     @click="fileLinkToStreamDownload(scope.row)"
                     >下载简历</span>
                </el-button>
                </div>
              </template>
            </el-table-column>
        </el-table>
         <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
      </div> 
            <el-dialog
      title="跟进记录"
    :visible.sync="centerDialogVisible1"
    width="50%"
    :append-to-body="true"
    center
      >
        <div class="followList-dialog">
                         <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  跟进
            </div>
             <div class="public-tit-list mft" style="cursor: pointer;"
             @click.stop="openAddfollowList"
             >
                <i class="icon-al-plus-circle-fill"></i>
                 添加跟进
             </div>
        </div>
            <div class="followList" v-if="followList.length">
                <div class="followList-item"
                v-for="(item, index) in followList" :key="index"
                >
                    <div class="remark">{{item.content}}</div>
                    <div class="info flex align-cen">
                        <div class="info-time">{{item.createTime}}</div>
                       <div class="info-username">{{item.createBy}}</div>
                    </div>
                </div>
             </div>
                      <div class="endowloadDetail-contaniner endowloadDetail-contaniner1" v-else>
            <span class="icon-al-wind-cry"></span>
            <p>暂无跟进</p>
        </div>
        </div>
      </el-dialog>
    </div>
</template>
<script>
import {resumeList,followList1,addFo1} from "@/api/index/index"  //简历列表、跟进列表
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import FileSaver from 'file-saver';
export default {
    name:'recruitDoc',
     components:{
      paginaTion
    },
    data() {
        return {
            centerDialogVisible1:false,
            totalNum:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount: 0,
            pageSizes:[10,20,30,40,50,100],
            itemList:[],
            followList:[],
            JobId:'',
        }
    },
    created () {
         this.gethisInfo()
    },
    methods: {
      // pdf 下载
      fileLinkToStreamDownload(data) {
          var oReq = new XMLHttpRequest()
          var URL= data.filePath // URL 为URL地址
          oReq.open('GET', URL, true)
          oReq.responseType = 'blob'
          oReq.onload = function() {
            var file = new Blob([oReq.response], {
              type: 'blob'
            })
            FileSaver.saveAs(file, data.name)
          }
          oReq.send()
    },
         // 打开添加跟进窗口
        openAddfollowList(){
                   this.$prompt('跟进内容', '添加跟进', {
                customClass:'follow-box',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputType:'textarea',
                inputPlaceholder:'必填【1-500】',
                inputPattern: /^\S{1,500}$/,
                inputErrorMessage: '输入不符合规则'
                }).then(({ value }) => {
                this.addFollow(this.JobId,value)
                }).catch(() => {       
                });
        },
        addFollow(id,content){
             // 打开跟进窗口
                addFo1({
                resumeId:id,
                content:content
              })
            .then(res => {
                if(res.code == 0){
                  this.$util.Notifi('添加成功','success','fa-check'); 
                  this.getFollowList(id)
                  this.gethisInfo()
                }else{
                   this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                }
            })
            .catch(err => {
            })
          },
         // 打开跟进窗口
        openWater(data){
            this.getFollowList(data.id)
            this.centerDialogVisible1 = true
        },
         getFollowList(id){
          followList1({
                id:id
              })
            .then(res => {
                this.JobId = id
                this.followList = res.data
            })
            .catch(err => {
            })
        },
           emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisInfo()
      },
        gethisInfo(){
  
             resumeList({
                id:this.$route.query.id,
                current: this.currentPage,
                size:this.PageSize,
            })
            .then(res => {
                console.log(res)
              this.itemList = res.data.records
              this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
    },
}
</script>
<style lang="scss" scoped>
::v-deep {
     .el-dialog{
      
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
              .followList{
                padding: 10px;
                padding-top: 0;
                height: 400px;
                overflow: hidden;
                overflow-y: auto;
                .followList-item{
                    border-bottom: 1px solid #ddd;
                    padding: 10px 0;
                    .info-username{
                        padding-left: 20px;
                        position: relative;
                    }
                    .info-username::before{
                        content: '';
                        width: 1px;
                        height: 20px;
                        background: #ccc;
                        position: absolute;
                        left: 10px;
                        top: 2px;
                    }
                }
                }

        }


}
</style>